import { Component, OnInit, OnDestroy, PLATFORM_ID, Inject, output, EventEmitter, Output, ChangeDetectorRef, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { ClientService } from '../../services/client-service';

interface TripResponse {
  success: boolean;
  message: string;
  activeTrip: boolean;
  activeTripId: string;
  ticket: {
    tripType: number;
    tripMode: number;
    initialAddress: string;
    destinationAddress: string;
    fare: number;
    status: number;
    driverId: string;
    driverFullName: string;
    driverPhoneNumber: string;
    driverPhoneCountry: string;
    driverCarModel: string;
    driverCarPlateNumber: string;
    taxiNum: number;
    scheduledDatetime: string;
    tripRequestTime: string;
    ref: string;
    ticketId: string;
  };
}

@Component({
  selector: 'app-trip-notification',
  templateUrl: './trip-notification.component.html',
  styleUrls: ['./trip-notification.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  
  imports: [CommonModule, RouterModule, TranslateModule]
})
export class TripNotificationComponent implements OnInit, OnDestroy {
  activeTrip: TripResponse | null = null;
  private refreshInterval: any;
  @Output() notifyDriver: EventEmitter<{ ticketId: string, isHasDriver: boolean }> = new EventEmitter<{ ticketId: string, isHasDriver: boolean }>();

  constructor(
    private clientService: ClientService,
        private _changeDetectorRef: ChangeDetectorRef,
    
    @Inject(PLATFORM_ID) private platformId: Object,
  ) {}

  ngOnInit(): void {
    
    if (this.platformId) {
      // Check immediately
      this.checkActiveTrip();

      
    }
  }

  ngOnDestroy(): void {
    if (this.refreshInterval) {
      clearInterval(this.refreshInterval);
    }
  }

  private checkActiveTrip(): void {
    this.clientService.getActiveTrip().subscribe({
      next: (trip: TripResponse) => {
        console.log('Active trip response:', trip);
        if (trip && trip.success && trip.activeTrip) {
          // alert('You have an active trip!');
          this.activeTrip = trip;
         
          this._changeDetectorRef.markForCheck();
        } else {
          this.activeTrip = null;
        }
      },
      error: (error) => {
        console.error('Error fetching active trip:', error);
        this.activeTrip = null;
      }
    });
  }

  isScheduledTrip(): boolean {
    if (!this.activeTrip?.ticket) return false;
    const now = new Date();
    const scheduledTime = new Date(this.activeTrip.ticket.scheduledDatetime);
    return scheduledTime.getTime() > now.getTime();
  }



  isNowTrip(): boolean {
    if (!this.activeTrip?.ticket) return false;

    const now = new Date();
    const tripRequestTime = new Date(this.activeTrip.ticket.tripRequestTime);
    const scheduledTime = this.activeTrip.ticket.scheduledDatetime 
      ? new Date(this.activeTrip.ticket.scheduledDatetime)
      : null;

    if (scheduledTime) {
      const timeDiff = scheduledTime.getTime() - now.getTime();
      const thirtyMinutesInMs = 30 * 60 * 1000;
      return timeDiff <= thirtyMinutesInMs && timeDiff >= -thirtyMinutesInMs;
    }

    const oneHourInMs = 60 * 60 * 1000;
    return (now.getTime() - tripRequestTime.getTime()) <= oneHourInMs;
  }

  getTimeMessage(): string {
    if (!this.activeTrip?.ticket) return '';

    const scheduledTime = this.activeTrip.ticket.scheduledDatetime 
      ? new Date(this.activeTrip.ticket.scheduledDatetime)
      : null;

    if (scheduledTime) {
      const timeStr = scheduledTime.toLocaleTimeString('fr-FR', { 
        hour: '2-digit', 
        minute: '2-digit' 
      });
      const dateStr = scheduledTime.toLocaleDateString('fr-FR', {
        day: '2-digit',
        month: '2-digit'
      });
      return `${timeStr} le ${dateStr}`;
    }
    return '';
  }

  dismiss(): void {

  }
  isHasDriver(): boolean {
    return this.activeTrip?.ticket?.driverId ? true : false;
  }

  returnToNotifyDriver(): void {

    this.notifyDriver.emit({ticketId: this.activeTrip?.ticket.ticketId?? '',isHasDriver:this.isHasDriver() });

  }
}
